import template from './select.html';
import controller from './select.controller';
import './select.scss';

let selectComponent = {
  restrict: 'E',
  bindings: {
    name: '@',
    required: '=',
    options: '<',
    onSelect: '&',
    placeholder: '@',
    disabled: '<',
    initialValue: '<',
    label: '@',
    limit: '<',
    inTwoLines: '<',
  },
  template,
  controller
};

export default selectComponent;



// WEBPACK FOOTER //
// ./client/app/components/select/select.component.js